module.exports = __webpack_public_path__ + "img/playing.5fdb64fe.gif";